module.exports = __webpack_public_path__ + "static/mockup_phone-7128e6be88398859efd2c398990dbd02.png";